export default "__VITE_ASSET__juRC6Oeu__"